{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "internal_ip_filter",
  "title": "Internal IP filter (staff)",
  "description": "Cross-client staff IP list — visits from these IPs are excluded from every client dashboard.",
  "x-access": "staff",
  "type": "object",
  "properties": {
    "enabled": {
      "type": "boolean",
      "x-access": "staff",
      "ui:tooltip": "Turn the global filter on or off without deleting the IP list.",
      "ui:description": "When on, visits from the IPs below are excluded from every client's dashboard stats. Turn off to temporarily include them again without losing the list."
    },
    "excluded_ips": {
      "type": "array",
      "maxItems": 100,
      "x-access": "staff",
      "ui:description": "One IP per row. Add a label so you remember who each one belongs to (e.g. 'Benoit home VPN', 'Paris office'). IPv4 and IPv6 are both accepted. For ranges, list each IP individually.",
      "items": {
        "type": "object",
        "required": [
          "label",
          "ip"
        ],
        "properties": {
          "label": {
            "type": "string",
            "minLength": 1,
            "maxLength": 100,
            "ui:description": "Short name to remember this IP (e.g. 'Benoit home')."
          },
          "ip": {
            "type": "string",
            "minLength": 1,
            "maxLength": 45,
            "ui:description": "IPv4 or IPv6 address. Paste the IP exactly as it appears (e.g. 203.0.113.42 or 2001:db8::1)."
          }
        }
      }
    }
  },
  "default": {
    "enabled": false,
    "excluded_ips": []
  }
}
